// A new deposit promotion on the promotions page starts from the CMS template (Thông số vận hành >
// khuyenMaiMau, backend lib/tham_so.js), never from numbers written here (owner 2026-10-04).
export type KhuyenMaiMau = { phanTram: number; toiDa: number; napToiThieu: number; vongCuoc: number };

export function khuyenMaiMoi(mau: KhuyenMaiMau, soThu: number) {
  return {
    ma: 'KM_' + soThu, ten: 'Khuyến mãi mới', loai: 'NAP' as const, bat: false, nhan: 'MỚI', moTa: '', dieuKhoan: '',
    phanTram: mau.phanTram, toiDa: mau.toiDa, napToiThieu: mau.napToiThieu, lanNap: 0 as const, kenh: 'tat_ca' as const,
    vongCuoc: mau.vongCuoc, gocCuoc: 'NAP_THUONG' as const,
  };
}
